import React, { useState } from 'react';

import Modal from './Modal';
import { setXapDismissed } from '../helpers/xap';
import useImpression from '../hooks/useImpression';

export default ({
  eligible,
  dismissed,
}) => {
  if (!eligible) return null;
  const [isOpen, setIsOpen] = useState(!dismissed);
  useImpression({
    placementName: 'xap-interstitial',
    componentName: 'xap-alert',
    if: isOpen,
  });

  const closeModal = () => {
    setXapDismissed(true);
    setIsOpen(false);
  };

  const makePayment = () => {
    closeModal();
    const { protocol, host } = window.location;
    const payments = host.replace(/^customer\./, 'payments.').replace(/-/, '');
    window.location = `${protocol}//${payments}/new`;
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
    >
      <div tracking-module="xap-interstitial" className="text-center">
        <h2>An important update on your Xfinity account</h2>
        <p>
          We’ve transferred your account to the Xfinity Assistance Plan to keep you connected at
          this time. You will receive basic services for a lower price at least until June 30,
          2020, or until your past due balance is paid. We will restore your current Xfinity
          services within 1 hour of payment. For more detail, please see your next billing
          statement.
        </p>
        <div className="action">
          <div className="action__item">
            <button
              type="button"
              className="button button--primary"
              onClick={makePayment}
            >
              Make a Payment
            </button>
          </div>
          <div className="action__item">
            <a
              className="button button--text"
              onClick={closeModal}
              href="https://xfinity.com/xap"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn More About this Plan
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};
